/* Spinder Design — Product-carousel: pijlen sturen het native scroll-track aan.
   Toetsenbord-/swipe-scrollen werkt sowieso; pijlen zijn een aanvulling.
   Respecteert prefers-reduced-motion (geen smooth scroll). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var track = root.querySelector('[data-pcar-track]');
    if (!track) return;
    var prev = root.querySelector('[data-pcar-prev]');
    var next = root.querySelector('[data-pcar-next]');
    var slide = track.querySelector('.spinder-pcar__slide');
    if (!slide) return;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function scrollByStep(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    function update() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
    if (next) next.addEventListener('click', function () { scrollByStep(1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    var carousels = document.querySelectorAll('.spinder-pcar');
    for (var i = 0; i < carousels.length; i++) initCarousel(carousels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.spinder-pcar');
    if (root) initCarousel(root);
  });
})();
